import { render, staticRenderFns } from "./SpatialViewParameter.vue?vue&type=template&id=75c41120&scoped=true&"
import script from "./SpatialViewParameter.vue?vue&type=script&lang=js&"
export * from "./SpatialViewParameter.vue?vue&type=script&lang=js&"
import style0 from "./SpatialViewParameter.vue?vue&type=style&index=0&id=75c41120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c41120",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCol,VRow,VSelect,VSlider})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c41120')) {
      api.createRecord('75c41120', component.options)
    } else {
      api.reload('75c41120', component.options)
    }
    module.hot.accept("./SpatialViewParameter.vue?vue&type=template&id=75c41120&scoped=true&", function () {
      api.rerender('75c41120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/SpatialViewParameter.vue"
export default component.exports